import i18n from 'utils/i18n'
import Button from "theme/Button";
import Text from "theme/Text";
import ThemedModal from 'components/atoms/ThemedModal'
import React, { useState } from 'react'
import MutateScan from 'utils/mutate/scan'
import { scanThroughConstants } from 'utils/constants/scan-constants'
import _ from 'lodash'

const ModalScan = ({ visible = false, employeeGuid, buildingGuid, onHide, reload }) => {
	
	const [ saving, setSaving ] = useState( false )
	
	const setVisible = () => {
		if( _.isFunction( onHide ) ) {
			onHide();
		}
	}
	
	const onScan = () => {
		MutateScan.scanIn( `building:${buildingGuid}`, {
			employeeGuid: employeeGuid,
			scannedInThrough: scanThroughConstants.QRCODE,
			callbackStart: setSaving.bind( this, true ),
			callbackSuccess: result => {
				if( _.isFunction( reload ) ) {
					reload({
						withLoading: false
					});
				}
				
				setVisible( false )
				setSaving( false )
			},
			callbackError: setSaving.bind( this, false ),
		});
	}
	
	return (
		<ThemedModal
			visible={ visible }
			setVisible={ setVisible.bind( this, false ) }
			title={ i18n.t('management:modal.scan.title') }
			footer={(
				<>
					<Button
						appearance="ghost"
						onPress={ setVisible.bind( this, false ) }>
						
						{ i18n.t('management:modal.basic.cancel' ) }
					</Button>
					
					<Button
						isLoading={ saving }
						onPress={ onScan.bind( this ) }>
						
						{ i18n.t('management:modal.scan.button_confirm') }
					</Button>
				</>
			)}>
			
			<Text>{ i18n.t('management:modal.scan.description') }</Text>
		</ThemedModal>
	)
}

export default ModalScan
